// src/utils/getMergedEmbedOption.ts
var getMergedEmbedOption = (mediaId, optionKey, optionValue) => {
  let finalEmbedOption = optionValue;
  if (typeof window === "undefined") {
    return finalEmbedOption;
  }
  if (window.wistiaOptions?._all?.[optionKey] !== void 0) {
    finalEmbedOption = window.wistiaOptions._all[optionKey];
  }
  const mediaIdOptions = window.wistiaOptions?.[mediaId];
  if (mediaIdOptions !== void 0) {
    const mediaIdOptionValue = mediaIdOptions[optionKey];
    if (optionValue !== void 0) {
      finalEmbedOption = mediaIdOptionValue;
    }
  }
  return finalEmbedOption;
};

// src/utils/swatch.ts
var getSwatchMetaData = async (url) => {
  const swatch = new Image();
  swatch.src = url;
  await swatch.decode();
  return swatch;
};
var swatchUrl = (mediaId, embedHost) => `https://${embedHost}/embed/medias/${mediaId}/swatch`;
var getSwatchAspectRatio = async (mediaId, embedHost = "fast.wistia.com") => {
  const swatchImg = await getSwatchMetaData(swatchUrl(mediaId, embedHost));
  const { naturalHeight, naturalWidth } = swatchImg;
  return naturalWidth / naturalHeight;
};
var defaultSwatchCSSProperties = ({
  mediaId,
  embedHost = "fast.wistia.com",
  aspect = 1.7,
  shouldLoadSwatch = true
}) => {
  return {
    aspectRatio: `${aspect}`,
    background: shouldLoadSwatch ? `center / contain no-repeat url(${swatchUrl(mediaId, embedHost)})` : void 0,
    display: "block",
    filter: "blur(5px)",
    width: "100%"
  };
};

export {
  getMergedEmbedOption,
  getSwatchAspectRatio,
  defaultSwatchCSSProperties
};
